import { Row, Col, Button } from "reactstrap";
import React from "react";
import ModalFrame from "../../../toolkit/modalFrame";
import { withFirebase } from "react-redux-firebase";
import { connect } from "react-redux";
import withStyles from "isomorphic-style-loader/withStyles";
import s from "./styles.scss";
import {
  RequestComponent,
  RequestComponentProps,
  RequestComponentState,
  DisplayState,
} from "../../../toolkit/requestComponent";
import { ScaleLoader } from "react-spinners";
import { serviceCaller } from "../../composition";
import { isCurrentUserCollaborator } from "../../../utils/roleCheck";

class RequestContentPage extends RequestComponent<
  RequestComponentProps,
  RequestComponentState
> {
  state = {
    displayState: "normal" as DisplayState,
  };

  onSubmit = () => {
    const request = {
      senderId: this.props.request.senderId,
      message: this.props.request.message,
      recipients: this.props.request.recipients,
      createdOn: this.props.request.createdOn,
      resend: true,
    };
    this.submitRequest(request, true);
  };

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      this.setState({
        displayState: "normal",
      });
    }
  }

  getDateString(epochDate: number): string {
    const options = {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "numeric",
      minute: "numeric",
    } as const;
    return new Date(epochDate).toLocaleDateString("en-US", options);
  }

  render() {
    const date =
      this.props.request && this.props.request.createdOn
        ? this.getDateString(this.props.request.createdOn)
        : undefined;
    return (
      <ModalFrame
        isOpen={this.props.isOpen}
        toggle={() => this.props.toggle()}
        size="lg"
        title={"Request Detail"}
      >
        <Row>
          <Col>
            <i className={s.date}>{date}</i>
          </Col>
        </Row>
        {this.props.request && this.props.request.senderInfo ? (
          <div>
            <p className={s.label}>Sender</p>
            <Row className={s.usersPadding} noGutters={true}>
              <Col xs={{ size: 11, offset: 1 }}>
                <p className={s.userInfo}>
                  {this.props.request.senderInfo.name} (
                  {this.props.request.senderInfo.email})
                </p>
              </Col>
            </Row>
            <hr />
          </div>
        ) : (
          ""
        )}
        {this.props.request &&
        this.props.request.recipientsInfo &&
        this.props.request.recipientsInfo.length > 0 ? (
          <div>
            <br />
            <p className={s.label}>Recipients</p>
            {this.props.request.recipientsInfo.map(user => {
              return (
                <Row key={user.id} noGutters={true} className={s.usersPadding}>
                  <Col xs={{ size: 11, offset: 1 }}>
                    <p className={s.userInfo}>{user.name}</p>
                  </Col>
                </Row>
              );
            })}
            <hr />
          </div>
        ) : (
          ""
        )}
        {this.props.request ? (
          <div>
            <br />
            <p className={s.label}>Message</p>
            <Row className={s.marginBot}>
              <Col xs={{ size: 10, offset: 1 }}>
                <p className={s.message}>{this.props.request.message}</p>
              </Col>
            </Row>
          </div>
        ) : (
          ""
        )}
        {this.state.displayState === "normal" &&
        this.props.userId &&
        this.props.request &&
        this.props.request.senderId &&
        this.props.request.senderId === this.props.userId &&
        isCurrentUserCollaborator(this.props.currentCharity) ? (
          <Row className={s.marginBot}>
            <Col xs={{ size: 4, offset: 8 }} md={{ size: 2, offset: 10 }}>
              <Button className={s.button} onClick={this.onSubmit}>
                Resend
              </Button>
            </Col>
          </Row>
        ) : (
          ""
        )}
        {this.state.displayState === "executing" && (
          <Row>
            <Col xs={{ size: 2, offset: 9 }}>
              <ScaleLoader color={"#1f65b1"} loading />
            </Col>
          </Row>
        )}
        {this.state.displayState === "success" && (
          <Row>
            <Col xs="11">
              <p className={s.done}>Done!</p>
            </Col>
          </Row>
        )}
        {this.state.displayState === "error" && (
          <Row>
            <Col xs="11">
              <p className={s.error}>Something went wrong, try again later.</p>
            </Col>
          </Row>
        )}
      </ModalFrame>
    );
  }
}

const mapStateToProps = state => {
  const { user } = state;
  return {
    userId: user.id,
  };
};

export default connect<RequestComponentProps>(mapStateToProps)(
  serviceCaller(withFirebase(withStyles(s)(RequestContentPage)))
);
